import { render, staticRenderFns } from "./DialogProject.vue?vue&type=template&id=75494480"
import script from "./DialogProject.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogProject.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports